/**
 * Recently Viewed Products
 *
 * - Capture: on product pages, records the current product handle/id in
 *   localStorage. De-duplicates by handle and keeps the list capped.
 * - Render: on every page, reads the list and fetches each product's card
 *   from the Section Rendering API (sections/recently-viewed-card.liquid),
 *   which renders the theme's product-block snippet server-side so the
 *   cards look identical to featured-collection's rows layout. The section
 *   stays hidden when the list is empty.
 *
 * No external dependencies.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'recently_viewed_products';
  var MAX_ITEMS = 8;
  var TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
  var CARD_SECTION_ID = 'recently-viewed-card';

  function lsAvailable() {
    try {
      var k = '__rv_test__';
      localStorage.setItem(k, '1');
      localStorage.removeItem(k);
      return true;
    } catch (e) {
      return false;
    }
  }

  function read() {
    if (!lsAvailable()) return [];
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return [];
      var now = Date.now();
      return arr.filter(function (e) {
        return e && e.h && now - (e.t || 0) < TTL_MS;
      });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    if (!lsAvailable()) return;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) { /* quota / disabled */ }
  }

  function capture() {
    var marker = document.querySelector('[data-recently-viewed-capture]');
    if (!marker) return;
    var id = marker.getAttribute('data-product-id');
    var handle = marker.getAttribute('data-product-handle');
    if (!id || !handle) return;

    var list = read().filter(function (e) { return e.h !== handle; });
    list.unshift({ h: handle, i: parseInt(id, 10) || id, t: Date.now() });
    write(list.slice(0, MAX_ITEMS));
  }

  /**
   * Fetch one rendered product card via the Section Rendering API.
   * Resolves with the card element, or null if unavailable.
   */
  function fetchCard(handle, rootUrl) {
    return fetch(rootUrl + 'products/' + handle + '?section_id=' + CARD_SECTION_ID, {
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) return null;
        return r.text();
      })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('.product-block');
      })
      .catch(function () {
        return null;
      });
  }

  function render() {
    var mount = document.querySelector('[data-recently-viewed-mount]');
    if (!mount) return;

    var captureMarker = document.querySelector('[data-recently-viewed-capture]');
    var currentHandle = captureMarker ? captureMarker.getAttribute('data-product-handle') : null;

    var list = read()
      .filter(function (e) { return e.h !== currentHandle; })
      .slice(0, MAX_ITEMS);

    if (list.length === 0) {
      mount.hidden = true;
      return;
    }

    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root_url) || '/';

    Promise.all(list.map(function (e) {
      return fetchCard(e.h, rootUrl);
    })).then(function (cards) {
      var grid = mount.querySelector('[data-recently-viewed-grid]');
      if (!grid) return;

      var valid = cards.filter(function (c) { return !!c; });
      if (valid.length === 0) {
        mount.hidden = true;
        return;
      }

      valid.forEach(function (card) {
        grid.appendChild(document.adoptNode(card));
      });
      mount.hidden = false;
    });
  }

  capture();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();